import { Routes, Route } from 'react-router-dom'
import { ServiceSelectionPage, RedirectPage, CallPage } from '@/pages'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ServiceSelectionPage />} />
      <Route path="/redirect/:service" element={<RedirectPage />} />
      <Route path="/call" element={<CallPage />} />
      {/* Catch all route - redirect to home */}
      <Route path="*" element={<ServiceSelectionPage />} />
    </Routes>
  )
}
